import { SettingsMenuEnum } from 'modules/profile/enums/settings-menu-enum'

export const getMenuItemDataTestId = (item: SettingsMenuEnum) => {
  switch (item) {
    case SettingsMenuEnum.my_plan:
      return 'my-plan-settings-link'
  }
}
